export default {
    szServiceTel:  '021-80187315', // 善诊客服电话
    ATT_URL: process.env.ATT_URL, // 一代报告语音前缀
}




